import { HSLColor } from '@yola/yola-palette-generator';

const headerSocialIconsActiveRule = ({ targetColor }) => {
  const { hue, saturation, lightness, alpha } = targetColor;
  const colorInstance = new HSLColor(hue, saturation, lightness, alpha);

  colorInstance.setAlpha(0.4);
  return colorInstance;
};

export default headerSocialIconsActiveRule;
